import { AppThunk } from "../appStore"
import { selectFusionApiAxios } from "../selectAxios"
import { onlineHttpError } from "./handleApiError"
import { getFrontendRequired, XFrontendRequired } from "../../lib/XFrontend"
import { setLdng } from "../appSlice"
import z from "zod"
import { err, ok, Result } from "neverthrow"
import { syncHttpReq, SyncHttpReqConfig, SyncHttpReqResultError } from "@fusion-advantage/formrender"
import { appError } from "../errorSlice"
import { safeParseJson, serializeFusionError } from '@fusion-advantage/backcompat'

interface apiInitiateLoginRequest {
	Platform: 'ios'|'web'
}

const ZApiInitiateLoginBody = z.object({
	Url: z.string(),
})
type ApiInitiateLoginBody = z.infer<typeof ZApiInitiateLoginBody>

type apiInitiateLoginOk = ApiInitiateLoginBody & {
	XFrontendRequired: XFrontendRequired|null
}

export const apiInitiateLogin = (req: apiInitiateLoginRequest): AppThunk<Promise<Result<apiInitiateLoginOk, void>>> => async (dispatch, getState) => {
	dispatch(setLdng({login: true}))
	const axInst = selectFusionApiAxios(getState())
	const cfg: SyncHttpReqConfig = {
		axInst,
		method: 'POST',
		url: '/api/v0/saml/initiate-login',
		data: req,
	}
	const r = await syncHttpReq(cfg)
	dispatch(setLdng({login: false}))
	if(r.isErr()) {
		dispatch(appError(onlineHttpError(cfg, r.error, {})))
		return err()
	}
	const rParse = safeParseJson(r.value.data, ZApiInitiateLoginBody)
	if(rParse.isErr()) {
		dispatch(appError({
			err: serializeFusionError('apiInitiateLogin', rParse.error)
		}))
		return err()
	}
	const rFrontendRequired = getFrontendRequired(r.value.axResp)
	if(rFrontendRequired.isErr()) {
		dispatch(appError({
			err: serializeFusionError('apiInitiateLogin', rFrontendRequired.error)
		}))
		return err()
	}
	return ok({
		...rParse.value,
		XFrontendRequired: rFrontendRequired.value,
	})
}

export const apiLogout = (): AppThunk<Promise<Result<void, SyncHttpReqResultError>>> => async (dispatch, getState) => {
	dispatch(setLdng({login: true}))
	const axInst = selectFusionApiAxios(getState())
	const cfg: SyncHttpReqConfig = {
		axInst,
		method: 'GET',
		url: '/api/v0/saml/logout',
	}
	const r = await syncHttpReq(cfg)
	dispatch(setLdng({login: false}))
	if(r.isErr()) {
		return err(r.error)
	}
	return ok()
}
